var AvailableDocumentsController = /** @class */ (function () {
    /*@ngInject*/
    function AvailableDocumentsController($rootScope, documentActionService, sharedAjsService) {
        this.$rootScope = $rootScope;
        this.documentActionService = documentActionService;
        this.sharedAjsService = sharedAjsService;
    }
    AvailableDocumentsController.prototype.$onInit = function () {
        this.savingFlag = false;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this._setFolderDetails();
        if (this.attachedDocuments.length > 0) {
            var selectedCandidateDocumentIds_1 = [];
            var selectedJobMatchDocumentIds_1 = [];
            this.attachedDocuments.map(function (doc) {
                if (doc.isJobMatchDocument) {
                    selectedJobMatchDocumentIds_1.push(doc.id);
                }
                else {
                    selectedCandidateDocumentIds_1.push(doc.id);
                }
            });
            this._setDocumentSelectionToFolders(selectedCandidateDocumentIds_1, selectedJobMatchDocumentIds_1);
        }
        else {
            this.attachedDocuments = [];
            if (this.candidateJobMatchFolders.length > 0 || this.folders.length > 0) {
                this._setDocumentSelectionToFolders(null, null);
            }
        }
    };
    AvailableDocumentsController.prototype._setFolderDetails = function () {
        this.folders = this.folders ? this.folders : [];
        if (this.candidateJobMatchFolders && this.candidateJobMatchFolders.length > 0) {
            this.candidateJobMatchFolders.map(function (jobMatch) {
                jobMatch.isJobMatchDocument = true;
                jobMatch.documents.map(function (document) {
                    document.isJobMatchDocument = true;
                });
            });
        }
        else {
            this.candidateJobMatchFolders = [];
        }
    };
    AvailableDocumentsController.prototype.attachDocuments = function () {
        this.onAttachDocuments({ documents: this.attachedDocuments });
    };
    AvailableDocumentsController.prototype.cancel = function () {
        if (this.cancelCallback) {
            this.cancelCallback();
        }
    };
    AvailableDocumentsController.prototype._setAttachedDocuments = function (file) {
        if (file.selected) {
            var checkIfDocExists_1 = false;
            this.attachedDocuments.every(function (doc) {
                if (doc.id === file.id) {
                    checkIfDocExists_1 = true;
                    return false;
                }
                return true;
            });
            if (!checkIfDocExists_1) {
                this.attachedDocuments.push(file);
            }
        }
        else {
            this.attachedDocuments = this.attachedDocuments.filter(function (doc) { return file.id != doc.id; });
        }
    };
    AvailableDocumentsController.prototype._checkAndSetDocumentsToSelected = function (selectedDocumentIds, documents) {
        documents.forEach(function (document) {
            document.selected = (selectedDocumentIds && selectedDocumentIds.includes((document.id))) ? true : false;
        });
    };
    AvailableDocumentsController.prototype._checkIfAllDocumentsSelected = function (documents) {
        var isAllParentDocumentsSelected = true;
        documents.every(function (document) {
            if (!document.selected) {
                isAllParentDocumentsSelected = false;
                return false;
            }
            return true;
        });
        return isAllParentDocumentsSelected;
    };
    AvailableDocumentsController.prototype._setDocumentSelectionToFolders = function (selectedCandidateDocumentIds, selectedJobMatchDocumentIds) {
        var _this = this;
        if (this.candidateJobMatchFolders.length > 0) {
            this.candidateJobMatchFolders.map(function (folder) {
                if (folder.documents.length > 0) {
                    _this._checkAndSetDocumentsToSelected(selectedJobMatchDocumentIds, folder.documents);
                }
            });
            this.candidateJobMatchFolders.map(function (folder) {
                var isAllDocumentsSelected = true;
                if (folder.documents.length > 0) {
                    isAllDocumentsSelected = _this._checkIfAllDocumentsSelected(folder.documents);
                }
                folder.selected = isAllDocumentsSelected;
            });
        }
        if (this.folders.length > 0) {
            this.folders.map(function (parentFolder) {
                if (parentFolder.documents.length > 0) {
                    _this._checkAndSetDocumentsToSelected(selectedCandidateDocumentIds, parentFolder.documents);
                }
                if (parentFolder.folders.length > 0) {
                    parentFolder.folders.map(function (childFolder) {
                        if (childFolder.documents.length > 0) {
                            _this._checkAndSetDocumentsToSelected(selectedCandidateDocumentIds, childFolder.documents);
                        }
                    });
                }
            });
            this.folders.map(function (parentFolder) {
                var isAllParentDocumentsSelected = true;
                var isAllChildFolderDocumentsSelected = true;
                if (parentFolder.documents.length > 0) {
                    isAllParentDocumentsSelected = _this._checkIfAllDocumentsSelected(parentFolder.documents);
                }
                if (parentFolder.folders.length > 0) {
                    parentFolder.folders.map(function (childFolder) {
                        if (childFolder.documents.length > 0) {
                            childFolder.selected = _this._checkIfAllDocumentsSelected(childFolder.documents);
                            if (!childFolder.selected) {
                                isAllChildFolderDocumentsSelected = false;
                            }
                        }
                    });
                }
                parentFolder.selected = (!isAllChildFolderDocumentsSelected || !isAllParentDocumentsSelected) ? false : true;
            });
        }
    };
    AvailableDocumentsController.prototype._setAttachedDocumentsToFolders = function (file, folder) {
        var _this = this;
        var allDocumentsSelected = true;
        folder.documents.forEach(function (document) {
            if (file.id == document.id) {
                document.selected = file.selected;
            }
            if (!document.selected) {
                allDocumentsSelected = false;
            }
        });
        folder.selected = allDocumentsSelected;
        if (folder.parentFolderId) {
            this.folders.map(function (parentFolder) {
                if (parentFolder.id == folder.parentFolderId) {
                    if (!allDocumentsSelected) {
                        parentFolder.selected = allDocumentsSelected;
                    }
                    else {
                        var isAllParentDocumentsSelected = _this._checkIfAllDocumentsSelected(parentFolder.documents);
                        parentFolder.selected = isAllParentDocumentsSelected;
                    }
                }
            });
        }
    };
    AvailableDocumentsController.prototype.toggle = function (scope) {
        scope.toggle();
    };
    AvailableDocumentsController.prototype.selectFolderWithDocuments = function (folder) {
        var _this = this;
        var isFolderSelected = folder.selected;
        if (folder.documents.length > 0) {
            folder.documents.forEach(function (document) {
                document.selected = isFolderSelected;
                _this._setAttachedDocuments(document);
            });
        }
        if (folder.folders.length > 0 && folder.folders[0].documents.length > 0) {
            folder.folders[0].selected = isFolderSelected;
            folder.folders[0].documents.forEach(function (document) {
                document.selected = isFolderSelected;
                _this._setAttachedDocuments(document);
            });
        }
        if (folder.parentFolderId) {
            var isParentFolderAllDocumentsSelected_1 = true;
            this.folders.every(function (parentFolder) {
                if (parentFolder.id == folder.parentFolderId) {
                    if (parentFolder.documents.length > 0) {
                        isParentFolderAllDocumentsSelected_1 = _this._checkIfAllDocumentsSelected(parentFolder.documents);
                    }
                    parentFolder.selected = isParentFolderAllDocumentsSelected_1 && isFolderSelected ? true : false;
                    return false;
                }
                return true;
            });
        }
    };
    AvailableDocumentsController.prototype.getAndSetFolderToAttachedDocuments = function (file) {
        var folder = [];
        var folders = file.isJobMatchDocument ? this.candidateJobMatchFolders : this.folders;
        folders.map(function (parentFolder) {
            if (parentFolder.id === file.folderId) {
                folder = parentFolder;
            }
            else if (parentFolder.folders.length > 0) {
                parentFolder.folders.every(function (childFolder) {
                    if (childFolder.id == file.folderId) {
                        folder = childFolder;
                        return false;
                    }
                    return true;
                });
            }
        });
        this._setAttachedDocumentsToFolders(file, folder);
    };
    AvailableDocumentsController.prototype.selectAndDeselectDocument = function (file, folder) {
        if (folder) {
            this._setAttachedDocuments(file);
            this._setAttachedDocumentsToFolders(file, folder);
        }
        else {
            file.selected = !file.selected;
            this._setAttachedDocuments(file);
            this.getAndSetFolderToAttachedDocuments(file);
        }
    };
    AvailableDocumentsController.prototype.viewDocumentFIle = function (file) {
        this.sharedAjsService.viewDocumentFIle(file, function (data) {
        }, function (error) {
        });
    };
    return AvailableDocumentsController;
}());
AvailableDocumentsController.$inject = ['$rootScope', 'documentActionService', 'sharedAjsService'];
// import * as TEMPLATE from './available-documents.html';
import * as TEMPLATE from 'raw-loader!./available-documents.html';
export var AvailableDocumentsComponent = {
    selector: 'availableDocuments',
    component: {
        bindings: {
            availableDocuments: '<',
            attachedDocuments: '<',
            folders: '<',
            candidateJobMatchFolders: '<',
            candidateId: '@',
            onAttachDocuments: '&',
            saveCallback: '&',
            cancelCallback: '&'
        },
        controller: AvailableDocumentsController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateprofile/candidateProfile/candidateDocuments/availableDocuments/available-documents.html'
    }
};
//# sourceMappingURL=available-documents.component.js.map